module.exports = __webpack_public_path__ + "assets/img/thumb-Blue-Microphones-Langing-page.9be1433a.webp";